import { fieldValueTypes, IField } from '@pbl/pbl-react-core/lib/models/forms/types';
import { ITicketTab } from '@pbl/pbl-react-core/lib/models/ticket/types';

export interface ITicketField<T> extends IField<T> {}

export type LoginFields = Array<ITicketField<fieldValueTypes>>;

const gameNumberField: ITicketField<string> = {
  type: 'string',
  key: 'gameNumber',
  label: 'Game Number',
  get placeholder(): string {
    return this.label;
  },
  isRequired: true,
  get fieldValue() {
    return this.value;
  }
};

const bookNumberField: ITicketField<string> = {
  type: 'string',
  key: 'bookNumber',
  label: 'Book Number',
  get placeholder(): string {
    return this.label;
  },
  isRequired: true,
  get fieldValue() {
    return this.value;
  }
};

const ticketNumberField: ITicketField<string> = {
  type: 'string',
  key: 'ticketNumber',
  label: 'Ticket Number',
  get placeholder(): string {
    return this.label;
  },
  isRequired: true,
  get fieldValue() {
    return this.value;
  }
};

const validationCodeField: ITicketField<string> = {
  type: 'string',
  key: 'validationCode',
  label: 'VIRN Number',
  get placeholder(): string {
    return this.label;
  },
  isRequired: true,
  get fieldValue() {
    return this.value;
  }
};

export const getTicketTab = (drawTicketTitle?: string): ITicketTab[] => [
  {
    tabKey: 'scratchTicket',
    tabTitle: 'ticket.scratch.tabTitle',
    fields: [
      {
        key: 'Ticket-Barcode-Number',
        label: 'ticket.scratch.ticketNumberLabel',
        placeholder: '000-000000-000',
        maskKey: 'TicketBarcodeInputMask',
        mask: [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
        min: 12,
        numbersOnly: true
      },
      {
        key: 'Validation-Number',
        label: 'ticket.scratch.entryCodeLabel',
        placeholder: '00000000-0000',
        maskKey: 'TicketValidationInputMask',
        mask: [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        min: 12,
        numbersOnly: true
      }
    ],
    sampleImageLink: 'ticket.sampleImageLink',
    sampleImage: '',
    eligibleGamesEnabled: false,
    eligibleGameText: 'ticket.eligibleGames',
    eligibleGameLinkText: 'ticket.eligibleGamesLink'
  },
  {
    tabKey: 'drawTicket',
    tabTitle: !!drawTicketTitle ? drawTicketTitle : 'ticket.draw.tabTitle',
    fields: [
      {
        key: 'Ticket-Entry-Code',
        label: 'ticket.draw.entryCodeLabel',
        placeholder: '00000-00000-00000-00000-00000',
        maskKey: 'TicketEntryCodeInputMask',
        mask: [
          /[A-Za-z0-9]/,
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          '-',
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          '-',
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          '-',
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          '-',
          /\w/,
          /\w/,
          /\w/,
          /\w/,
          /\w/
        ],
        min: 25,
        numbersOnly: false
      }
    ],
    sampleImageLink: 'ticket.sampleImageLink',
    sampleImage: '',
    eligibleGamesEnabled: false
  }
];

export const helpTabs = [
  {
    tabKey: 'scratchTicket',
    tabTitle: '',
    sampleImage: 'https://gw-uat.pbl.nclottery.com/media/api/file/49/59f63c00-f861-4dc9-81a2-8f810cef5775',
    parentTabKey: 'scratchticket'
  },
  {
    tabKey: 'drawTicket',
    tabTitle: '',
    sampleImage: 'https://gw-uat.pbl.nclottery.com/media/api/file/49/247461be-bf4d-4d68-85d1-019fab718820',
    parentTabKey: 'drawTicket'
  }
  
  
];

export const ticketFields: LoginFields = [gameNumberField, bookNumberField, ticketNumberField, validationCodeField];
